import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

// Lấy bảng điều khiển chấm công
export function layBangDieuKhienChamCong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/bao-cao/thong-ke', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy thống kê chấm công
export function layThongKeChamCong(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get('/cham-cong/bao-cao/thong-ke-chi-tiet', { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
